import { FormControl, InputLabel, MenuItem, Select, styled, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { ControlledTextInput } from '../../components/ControlledTextInput';
import type { XeroRegisterFormControl } from './XeroRegisterFormSchema';

interface Props {
  control: XeroRegisterFormControl;
}

export const XeroRegistration: FC<Props> = ({ control }) => {
  return (
    <FormContainer>
      <LogoContainer>
        <VyIcon
          icon="XeroLogoIcon"
          style={{
            transform: 'scale(0.5)',
            transformOrigin: 'top left',
          }}
        />
      </LogoContainer>
      <Typography variant="h4">Enter your Xero credentials to get started</Typography>
      <ControlledTextInput
        name="clientId"
        control={control}
        label="Client ID"
        placeholder="Enter Client ID here..."
        defaultValue=""
      />
      <ControlledTextInput
        name="clientSecret"
        control={control}
        label="Client Secret"
        placeholder="Enter Client Secret here..."
        defaultValue=""
      />
      <Controller
        name="environment"
        control={control}
        defaultValue="production"
        render={({ field }) => (
          <FormControl fullWidth>
            <InputLabel>Environment</InputLabel>
            <Select {...field} label="Environment">
              <MenuItem value="production">Production</MenuItem>
              <MenuItem value="sandbox">Sandbox</MenuItem>
            </Select>
          </FormControl>
        )}
      />
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const LogoContainer = styled('div')({
  width: 132,
  height: 132,
});
